import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 39"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7.559 1.235 31.939 15.5c3.084 1.802 3.084 6.22 0 8.021L7.56 37.786c-3.14 1.84-7.11-.404-7.11-4.013V5.248c0-3.61 3.97-5.852 7.11-4.013" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }